import type { IExamAttemptQuestionsResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@/api/util/createGetApi";
import type { ICourseResponse } from "@/api/courses/types";
import type { IInteractiveExamResponse } from "@api/courses/exams/interactive/types";
import type { IInteractiveExamAttemptResponse } from "@api/courses/exams/interactive/attempts/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<
      IExamAttemptQuestionsResponse,
      {
        course: ICourseResponse;
        exam: IInteractiveExamResponse;
        attempt: IInteractiveExamAttemptResponse;
      }
    >
  >,
  IPathBaseParam,
  IPaginationParams
>("courses.exams.interactive.interactiveExamAttempt.examAttemptQuestions");
const getApis = createGetApi<
  IApiResponse<IExamAttemptQuestionsResponse>,
  IPathByIdParam,
  object
>("courses.exams.interactive.interactiveExamAttempt.examAttemptQuestions");

export const examAttemptQuestions = {
  ...getAllApis,
  ...getApis,
};
